import { createContext, type ReactNode, useContext } from "react";

type WidthListener = () => void;

export interface ArticleLayoutSizeStore {
	getContentWidth: () => number;
	getContentWrapperWidth: () => number;
	setWidths: (contentWidth: number, contentWrapperWidth: number) => void;
	subscribe: (listener: WidthListener) => () => void;
}

export const createArticleLayoutSizeStore = (): ArticleLayoutSizeStore => {
	let contentWidth = 0;
	let contentWrapperWidth = 0;
	const listeners = new Set<WidthListener>();

	return {
		getContentWidth: () => contentWidth,
		getContentWrapperWidth: () => contentWrapperWidth,
		setWidths: (nextContentWidth, nextContentWrapperWidth) => {
			if (contentWidth === nextContentWidth && contentWrapperWidth === nextContentWrapperWidth) return;
			contentWidth = nextContentWidth;
			contentWrapperWidth = nextContentWrapperWidth;
			for (const listener of listeners) listener();
		},
		subscribe: (listener) => {
			listeners.add(listener);
			return () => listeners.delete(listener);
		},
	};
};

const ArticleLayoutSizeContext = createContext<ArticleLayoutSizeStore>(null);

export const ArticleLayoutSizeProvider = ({
	children,
	store,
}: {
	children: ReactNode;
	store: ArticleLayoutSizeStore;
}) => <ArticleLayoutSizeContext.Provider value={store}>{children}</ArticleLayoutSizeContext.Provider>;

export const useArticleLayoutSizeStore = () => useContext(ArticleLayoutSizeContext);
